// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2OaUo","content":"LoadingAlert_content__dRh2M"};